module.exports = __webpack_public_path__ + "img/profile_aggressive.617e2ac2.png";